import React, { useEffect, useState } from 'react';
import { Card, Col, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ItemShow from '../../components/Form/ItemShow';
import { LinkButton } from '../../styles/components/common/Button';
import { toast } from 'react-hot-toast';
import { Loading } from '../../components/Loading';

const TestimonialShow = () => {
      const { testimonialId } = useParams();
      const [testimonial, setTestimonial] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadPlugin = async () => {
            setLoadingData(true);

            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/testimonials/${testimonialId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setTestimonial(response.data.testimonial);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadPlugin();
      }, []);

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader>
                                          <CardTitle>
                                                Testimonial Detail
                                          </CardTitle>
                                          <CardLinks>
                                                <LinkButton to="/dashboard/testimonials">
                                                      Back
                                                </LinkButton>
                                          </CardLinks>
                                    </CardHeader>
                                    <Card.Body>
                                          {!loadingData ? (
                                                <Row>
                                                      <Col lg={6}>
                                                            <ListGroup>
                                                                  <ItemShow
                                                                        title="Name"
                                                                        value={
                                                                              testimonial.name
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Company Name"
                                                                        value={
                                                                              testimonial.company
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Position"
                                                                        value={
                                                                              testimonial.position
                                                                        }
                                                                  />

                                                                  <ItemShow
                                                                        title="Message"
                                                                        value={
                                                                              testimonial.message
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Status"
                                                                        value={
                                                                              testimonial.status ===
                                                                              1 ? (
                                                                                    <label className="text-success">
                                                                                          Active
                                                                                    </label>
                                                                              ) : (
                                                                                    <label className="text-danger">
                                                                                          Disabled
                                                                                    </label>
                                                                              )
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Created Date"
                                                                        value={
                                                                              testimonial.date
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Created By"
                                                                        value={
                                                                              testimonial.user_name
                                                                        }
                                                                  />
                                                            </ListGroup>
                                                      </Col>
                                                      <Col lg={6}>
                                                            <ListGroup>
                                                                  <ListGroupItem>
                                                                        <img
                                                                              src={
                                                                                    testimonial.image
                                                                              }
                                                                              alt={
                                                                                    testimonial.title
                                                                              }
                                                                              className=" p-2 rounded"
                                                                              style={{
                                                                                    width: '250px',
                                                                                    height: '250px',
                                                                                    objectFit:
                                                                                          'contain'
                                                                              }}
                                                                        />
                                                                  </ListGroupItem>
                                                            </ListGroup>
                                                      </Col>
                                                </Row>
                                          ) : (
                                                <>
                                                      <div
                                                            className="text-center d-flex align-items-center justify-content-center w-100"
                                                            style={{
                                                                  height: '30vh'
                                                            }}
                                                      >
                                                            <Loading />
                                                      </div>
                                                </>
                                          )}
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default TestimonialShow;
